import { SearchFacetElement } from '@obeta/models/lib/schema-models'

export const calcTotalSize = (facetElements: SearchFacetElement[]) => {
  return facetElements.reduce((acc, current) => {
    acc += current.count
    return acc
  }, 0)
}
